import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';

import { UserContext } from 'client/components/UserContext';
import SignInButtonModal from 'client/components/signin/SignInButtonModal';
import NotificationsMenu from './NotificationsMenu';

import {
  Header,
  HeaderLogo,
  HeaderLogoImgSmall,
  HeaderLogoImgLarge,
  HeaderLink,
  HeaderSpacer,
  HeaderProfile,
  HeaderProfileUserPic,
  HeaderProfileUserName,
  HeaderIconButton,
  HeaderLogoText,
} from './Header';

const GetStartedButton = ({ pathname }: { pathname: string }) => {
  const isCTA = !pathname.match(/\/events\/(\w*)/g);
  return (
    <div>
      <div className="large">
        <SignInButtonModal
          onLoginSuccess={() => {}}
          buttonClasses={`btn ${isCTA ? 'btn-primary' : 'btn-default'}`}
          buttonText="Get started"
        />
      </div>
      <div className="small">
        <SignInButtonModal
          onLoginSuccess={() => {}}
          buttonClasses={`btn btn-sm ${isCTA ? 'btn-primary' : 'btn-default'}`}
          buttonText="Get started"
        />
      </div>
    </div>
  );
};

const MenuLoggingIn = () => <div />;

const MenuLoggedIn = ({
  user,
  loading,
  pathname,
}: {
  user: { name: string; photo: string };
  loading: boolean;
  pathname: string;
}) => (
  <>
    {/* <HeaderLink>
      <Link to="/organize">
        <span className="large">Organize</span>
        <HeaderIconButton className="small fa fa-plus" />
      </Link>
    </HeaderLink> */}
    <HeaderLink>
      <Link to="/dashboard/communities">
        <span className="large">My Communities</span>
        <HeaderIconButton className="small fa fa-user-circle-o" />
      </Link>
    </HeaderLink>
    <HeaderLink>
      <Link to="/dashboard/events">
        <span className="large">My Events</span>
        <HeaderIconButton className="small fa fa-calendar" />
      </Link>
    </HeaderLink>
    <NotificationsMenu pathname={pathname} />
    <HeaderProfile>
      <Link to="/profile">
        <HeaderProfileUserPic
          style={{
            backgroundImage: `${loading ? 'linear-gradient(315deg, #d9d9d9 0%, #f6f2f2 74%)' : `url(${user.photo})`}`,
          }}
          title={loading ? 'Loading' : user.name}
        />
        {/* <HeaderProfileUserName className="large" style={{ visibility: loading ? 'hidden' : 'visible' }}>
          {user.name}
        </HeaderProfileUserName> */}
      </Link>
    </HeaderProfile>
  </>
);

const MenuAnonymous = ({ pathname }: { pathname: string }) => (
  <>
    <HeaderLink>
      <Link to="/how-it-works">
        <span className="large">How It Works</span>
        <HeaderIconButton className="small fa fa-info" />
      </Link>
    </HeaderLink>
    <HeaderProfile>
      <GetStartedButton pathname={pathname} />
    </HeaderProfile>
  </>
);

const AppHeader = () => {
  const { user, loggingIn, loading } = useContext(UserContext);
  const { pathname } = useLocation();

  return (
    <Header
      transparent={
        pathname === '/new' ||
        pathname === '/newnew' ||
        pathname === '/communities-intro' ||
        pathname.startsWith('/communities')
      }
    >
      <HeaderLogo>
        <Link className="non-text-link" to="/main">
          <HeaderLogoImgSmall
            className="small"
            src="https://static.introwise.com/images/introwise-logo-favicon.svg"
            alt=""
          />
          <HeaderLogoImgLarge className="large" src="https://static.introwise.com/images/introwise-logo.svg" alt="" />
        </Link>
        <Link className="non-text-link large" to="/main">
          <HeaderLogoText className="large">introwise</HeaderLogoText>
        </Link>
      </HeaderLogo>
      {/* <HeaderLink>
            <Link to="/events">
              <span className="large">Discover Events</span>
              <HeaderIconButton className="small fa fa-search" />
            </Link>
          </HeaderLink> */}
      <HeaderSpacer>
        <div>&nbsp;</div>
      </HeaderSpacer>
      {loggingIn && <MenuLoggingIn />}
      {!loggingIn && user && <MenuLoggedIn user={user} pathname={pathname} loading={loading} />}
      {!loggingIn && !user && <MenuAnonymous pathname={pathname} />}
    </Header>
  );
};

const AppHeaderContainer = () => {
  // const { pathname } = useLocation();
  const unmounted = false; // pathname === '/';
  return !unmounted && <AppHeader />;
};

export default AppHeaderContainer;
